import { RiVipCrownFill } from "react-icons/ri";
import { AiTwotoneSound, AiFillDollarCircle } from "react-icons/ai";
import { HiOutlineClipboardList } from "react-icons/hi";
import { TbPokerChip, TbMessage, TbMoneybag } from "react-icons/tb";
import {
  BsCashCoin,
  BsListCheck,
  BsFileEarmarkRuledFill,
} from "react-icons/bs";
import { IoGift, IoSettings, IoWallet } from "react-icons/io5";
import {
  FaCrown,
  FaFileInvoiceDollar,
  FaHeadphonesAlt,
  FaRegCalendarCheck,
} from "react-icons/fa";
import { HiShare } from "react-icons/hi";
import { CgUserList } from "react-icons/cg";
import { FaPiggyBank, FaHistory } from "react-icons/fa";
import { RiHomeSmileFill } from "react-icons/ri";
import { BiMessageSquareAdd } from "react-icons/bi";
import { TiArrowSortedUp } from "react-icons/ti";
import { GiReceiveMoney } from "react-icons/gi";
import {
  openCache,
  openLanguagePop,
} from "../../redux/action/member/memberAction";
import { MdOutlineLanguage } from "react-icons/md";

const iconStyle = "text-2xl mr-[10px]";

export const MENU_LIST = ({ className, dispatch }) => {
  return [
    {
      icon: <IoWallet className={`${iconStyle} ${className}`} />,
      text: "profile",
      link: "data",
      iconColor: "#3FADA2",
    },
    {
      icon: <FaCrown className={`${iconStyle} ${className}`} />,
      text: "VIP",
      link: "vip",
      iconColor: "#D99E0A",
    },
    {
      icon: <HiShare className={`${iconStyle} ${className}`} />,
      text: "Refer-Code",
      link: "refer-code",
      iconColor: "#963EFF",
    },

    {
      icon: <FaPiggyBank className={`${iconStyle} ${className}`} />,
      text: "Deposit",
      link: "deposit",
      iconColor: "#D96209",
    },
    {
      icon: <AiFillDollarCircle className={`${iconStyle} ${className}`} />,
      text: "Withdraw",
      link: "withdraw",
      iconColor: "#3084FF",
      divider: true,
    },
    // {
    //   icon: <FaFileInvoiceDollar className={`${iconStyle} ${className}`} />,
    //   text: "point-query",
    //   link: "point-query",
    //   iconColor: "#FF6602",
    //   divider: true,
    // },

    {
      icon: <FaHistory className={`${iconStyle} ${className}`} />,
      text: "Bet Record",
      link: "betRecord",
      iconColor: "#D99E09",
    },
    {
      icon: <BsCashCoin className={`${iconStyle} ${className}`} />,
      text: "Transaction",
      link: "transaction",
      iconColor: "#48C0FF",
      divider: true,
    },
    // {
    //   icon: <HiShare className={`${iconStyle} ${className}`} />,
    //   text: "Refer Rule",
    //   link: "/referRule",
    // },
    // {
    //   icon: <GiReceiveMoney className={`${iconStyle} ${className}`} />,
    //   text: "Refer-Code",
    //   link: "/refer-code",
    // },
    {
      icon: <IoGift className={`${iconStyle} ${className}`} />,
      text: "Reward",
      link: "rewards",
      iconColor: "#6448FF",
    },

    {
      icon: <TbMessage className={`${iconStyle} ${className}`} />,
      text: "Inbox",
      link: "inbox",
      iconColor: "#3FAD66",
      divider: true,
    },
    {
      icon: <IoSettings className={`${iconStyle} ${className}`} />,
      text: "Settings",
      link: "settings",
      border: true,
      iconColor: "#88919A",
    },
    {
      icon: <FaHeadphonesAlt />,
      text: "serviceInformation",
      link: "../service-group",
      iconColor: "#88919A",
    },
    {
      icon: <IoSettings className={`${iconStyle} ${className}`} />,
      text: "ClearCache",
      link: "clear-cache",
      func: () => {
        dispatch(openCache());
      },
      border: true,
      iconColor: "#88919A",
    },

    {
      icon: <MdOutlineLanguage className={`${iconStyle} ${className}`} />,
      text: "Language",
      link: "language",
      func: () => {
        dispatch(openLanguagePop());
      },
      border: true,
      iconColor: "#88919A",
      divider: true,
    },
  ];
};
